<template>
	<div class="parts-locations-printing-card-edit">
		<!-- Invoice Printing Section -->
		<SectionContainer>
			<template #left>
				<h4>Invoice Printing</h4>
			</template>
			<template #content>
				<label for="printingCode">
					<span>
						Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs
					</span>
					<span>Affects Repair Orders and Back Counter.</span>
				</label>
				<Toggle
					id="printingCode"
					:labelInsideClassName="'toggle--label-in'"
					v-model="localData.invoicePrinting.printBarcode"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>

				<Dropdown
					label="Print SOP"
					subLabel="Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs."
					v-model="localData.invoicePrinting.printSOP"
					:options="printSOPTypeOptions"
				/>
				<Dropdown
					label="Print Prompt At Close"
					v-model="localData.invoicePrinting.printPromptAtClose"
					:options="printPromptAtCloseTypeOptions"
				/>
				<Dropdown
					label="Salesperson"
					v-model="localData.invoicePrinting.salesPerson"
					:options="salesPersonTypeOptions"
				/>
				<div>
					<Dropdown
						label="State Disclosure"
						subLabel="Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs"
						v-model="localData.invoicePrinting.stateDisclosures"
						:options="stateDisclosuresTypeOptions"
					/>
					<Button
						className="btn--icon-only"
						labelText="Delete"
						iconClassName="icon-show"
						:iconBeforeLabel="true"
					/>
				</div>
				<Input
					label="Parts Invoice Comment"
					v-model="localData.invoicePrinting.partsInvoiceComment"
				/>
				<Textarea
					label="Parts Invoice Disclaimer"
					:cols="30"
					:maxLength="200"
					v-model="localData.invoicePrinting.partsInvoiceDisclaimer"
				/>
			</template>
		</SectionContainer>
		<!-- Quote Printing Section -->
		<SectionContainer>
			<template #left>
				<h4>Invoice Printing</h4>
			</template>
			<template #content>
				<Dropdown
					label="Salesperson"
					v-model="localData.quotePrinting.salesPerson"
					:options="salesPersonTypeOptions"
				/>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Input from '@/components/forms/input/input';
import Button from '@/components/forms/button/button';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Textarea from '@/components/forms/textarea/textarea.vue';
import _ from 'lodash';

export default {
	name: 'PartsLocationsPrintingCardEdit',
	components: { SectionContainer, Input, Button, Dropdown, Toggle, Textarea },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			printSOPTypeOptions: ['For Clients', 'For Lorem', 'For Ipsum'],
			printPromptAtCloseTypeOptions: [
				'When Invoice Has CHanged',
				'When Lorem Ipsum'
			],
			salesPersonTypeOptions: ['Reik Smith', 'Jhon Rafter'],
			stateDisclosuresTypeOptions: ['Florida', 'California', 'New York']
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.parts-locations-printing-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
